import { useState } from "react";

import { useAxios } from "../../utils/useAxios";
import { ERROR_MESSAGES } from "../../constant/constant";
import { TENANT_DOMAIN } from "../../utils/domain";


/**
 * @typedef {object} profileResponseItem
 * @property {number} id
 * @property {number} age
 * @property {string} username
 * @property {string} name
 * @property {string} email
 * @property {number|null} total_quest
 * @property {number|null} completed_quest
 */

/**
 * Hook to fetch Student Quests
 * @returns {{
 *  profile: profileResponseItem[],
 *  loading: boolean,
 *  error: string,
 *  getQuests: () => Promise<void>
 * }}
 */
export const useGetSclStudentProfile = () => {
  const [profile, setProfile] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const { axiosInstance } = useAxios();

  const getProfile = async () => {
    try {
      setLoading(true);
      setError("");

      const response = await axiosInstance.get(
        `${TENANT_DOMAIN}/student/profile`,
      );

      setProfile(response?.data?.data || []);
    } catch (err) {
      setProfile([]);
      if (err?.response?.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        setError(err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
      }
    } finally {
      setLoading(false);
    }
  };

  return { profile, loading, error, getProfile };
};
